import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Input,
  Label,
} from "@egaranti/components";

import { useTranslation } from "react-i18next";

const WarrantyDateDialog = ({
  open,
  onOpenChange,
  selectedProduct,
  newWarrantyDate,
  onWarrantyDateChange,
  onSave,
  formatDateForInput,
  formatDateForDisplay,
}) => {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      onOpenChange={(open) => {
        onOpenChange(open);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(
              "clientsPage.editWarrantyDate",
              "Garanti Başlangıç Tarihini Değiştir",
            )}
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="space-y-2 py-4">
          <Label>
            {t("clientsPage.newStartDate", "Yeni Başlangıç Tarihi")}
          </Label>
          <Input
            type="datetime-local"
            defaultValue={formatDateForInput(
              selectedProduct?.warrantyStartDate,
            )}
            onChange={(e) => onWarrantyDateChange(e.target.value)}
          />
          {newWarrantyDate && (
            <div className="mt-4 flex gap-4">
              <p className="mt-1 text-gray-500 line-through">
                {formatDateForDisplay(selectedProduct?.warrantyStartDate)}
              </p>
              <p className="mt-1 text-green-600">
                {formatDateForDisplay(newWarrantyDate)}
              </p>
            </div>
          )}
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onWarrantyDateChange(null)}>
            {t("common.cancel", "İptal")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onSave}>
            {t("common.save", "Kaydet")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default WarrantyDateDialog;
